export enum PromotionIdEnum {
    COMBO_ENERGY=5,
}